var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurvaluesvg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6669 6.33325L22.7438 27.9999L13.0002 18.3703",
    stroke: "#000064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5224 20.5925C44.6192 21.3913 44.6674 22.1953 44.6668 22.9999C44.6668 27.2852 43.3961 31.4742 41.0153 35.0373C38.6346 38.6003 35.2507 41.3774 31.2916 43.0173C27.3326 44.6572 22.9761 45.0863 18.7732 44.2503C14.5703 43.4142 10.7097 41.3507 7.67952 38.3206C4.64939 35.2904 2.58584 31.4298 1.74982 27.2269C0.913812 23.0239 1.34288 18.6675 2.98278 14.7084C4.62268 10.7494 7.39975 7.36551 10.9628 4.98474C14.5259 2.60398 18.7149 1.33325 23.0002 1.33325C26.355 1.36456 29.6549 2.18952 32.6298 3.74066",
    stroke: "#000064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurvaluesvg4);
export default __webpack_public_path__ + "static/media/ourvaluesvg4.2f113e9a88ce0052fee3c3f4e64a52de.svg";
export { ForwardRef as ReactComponent };